(() => {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];

  function openCart() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }
  window.Hauntly = { openCart, closeCart };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    const close = event.target.closest('[data-cart-close]');
    const add = event.target.closest('[data-quick-add]');
    if (open) { event.preventDefault(); openCart(); }
    if (close) { event.preventDefault(); closeCart(); }

    if (add) {
      event.preventDefault();
      const id = add.dataset.quickAdd;
      add.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(id),quantity:1}]})
        });
        if (!response.ok) throw new Error('Could not add item');
        await refreshCart();
        openCart();
      } catch (e) {
        console.error(e);
        alert('This item could not be added. Please open the product page and try again.');
      } finally { add.disabled = false; }
    }
  });

  async function refreshCart() {
    const response = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
    if (!response.ok) return;
    const cart = await response.json();
    const count = $('[data-cart-count]');
    if (count) count.textContent = cart.item_count;
    const items = $('[data-cart-items]');
    const total = $('[data-cart-total]');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="empty">Your cart is waiting for something spooky. 👻</div>';
    } else {
      items.innerHTML = cart.items.map(item => `
        <div class="cart-line">
          <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">
          <div><h4>${escapeHtml(item.product_title)}</h4><p>Qty ${item.quantity}</p><p>${formatMoney(item.final_line_price)}</p></div>
        </div>`).join('');
    }
    if (total) total.textContent = formatMoney(cart.total_price);
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(cents/100);
  }
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  $$('.product-thumb').forEach(btn => btn.addEventListener('click', () => {
    const main = $('[data-product-main-image]');
    if (!main) return;
    main.src = btn.dataset.image;
    $$('.product-thumb').forEach(x => x.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));
})();